var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimer = function SvgTimer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64 79.76a59 59 0 1 0 15.06-56.8l-10.35-5.98a2 2 0 0 0-3 1.81l1.34 31.1a2 2 0 0 0 2.92 1.68l27.6-14.38a2 2 0 0 0 .07-3.5l-9.56-5.53a49 49 0 1 1-14.43 49 5 5 0 0 0-9.65 2.6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 30,
    x: 65.82,
    y: 58.32,
    rx: 4,
    transform: "rotate(135 69.82 73.32)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 29,
    x: 58,
    y: 39,
    rx: 4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimer);
export default ForwardRef;